import axios from "axios";
import {
    getUrlForApproveLeavePlan,
    getUrlForRejectLeavePlan,
} from "utils/endpointUtils/leavePlansEndpointUtil";
import { setAuthHeader } from "app/services/auth.header.service";

export const approveLeavePlan = (leaveId) => {
    const config = setAuthHeader();
    if (config === null) throw new Error("Invalid Auth Header or Token Expired");
    return axios.post(getUrlForApproveLeavePlan(leaveId), null, config);
};

export const rejectLeavePlan = (leaveId) => {
    const config = setAuthHeader();
    if (config === null) throw new Error("Invalid Auth Header or Token Expired");
    return axios.post(getUrlForRejectLeavePlan(leaveId), null, config);
};
